import type { SupabaseClient } from '@supabase/supabase-js';
import { FOLLOW_UP_OUTREACH_ACTIVITY_TYPES } from './followUpClosePrompt';

export async function hasOutreachActivityAfterFollowUpDue(
  supabase: SupabaseClient,
  opportunityId: number,
  dueAtIso: string,
): Promise<boolean> {
  const { data, error } = await supabase
    .from('opportunity_activities')
    .select('id')
    .eq('pipeline_opportunities_id', opportunityId)
    .gt('created_at', dueAtIso)
    .in('activity_type', [...FOLLOW_UP_OUTREACH_ACTIVITY_TYPES])
    .limit(1);

  if (error) {
    console.error('[follow-up prompt] Error checking outreach after due:', error);
    return false;
  }

  return (data?.length ?? 0) > 0;
}

export async function markOpportunityDetailsFirstOpened(
  supabase: SupabaseClient,
  opportunityId: number,
): Promise<void> {
  const { error } = await supabase
    .from('pipeline_opportunities')
    .update({ details_first_opened_at: new Date().toISOString() })
    .eq('id', opportunityId)
    .is('details_first_opened_at', null);

  if (error) {
    console.error('[follow-up prompt] Error marking first opened:', error);
  }
}
